<template>
  <div class=" mt-1">

    <div v-if="!upload.img_src " class="flex border-2 border-dashed border-gray-300  bg-indigo-50 items-center justify-center p-3 rounded-md">
      <div class="text-center space-y-1">
        <svg class="mx-auto h-6 w-6 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48"
          aria-hidden="true">
          <path
            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <div class="text-base text-gray-600">
          <label class="relative cursor-pointer  rounded-md font-medium text-indigo-600 hover:text-indigo-500">
            <span>Upload Photo</span>
            <input type="file" ref="photoUploadFileInput" class="sr-only " mul  tiple="true" accept="image/*"
              @change="onImageUpload($event)" />
          </label>
        </div>
        <small class="text-gray-600">
          <span> Photos are allowed in JPG or PNG format.</span>
        </small>
      </div>
    </div>

    <div v-else class=" border-2 border-dashed border-gray-300  items-center p-3 bg-indigo-50">
      <div  class=" m-auto overflow-hidden relative rounded-md max-h-96 max-w-5xl " style="height: 280px;width: 280px;">
        <img style="height: 280px;width: 280px;" :src="upload.img_src" alt="Avatar">
        <!-- Buttons -->
        <div
          class="absolute bg-opacity-75 flex flex-col h-full hover:opacity-100 items-center justify-end opacity-0 top-0 transform w-full z-10">
          <div class="backdrop-blur-md backdrop-filter flex flex-row justify-end p-2 w-full">
            <!-- Edit -->
            <button @click="editPhoto()" type="button"
              class=" mx-2 rounded-full bg-indigo-600 p-2 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
              </svg>
            </button>
            <!-- delete photo -->
            <button @click="deletePhoto()" type="button"
              class=" mx-2 rounded-full bg-red-600 p-2 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { helpers } from "../../../../mixins/helpers.js";

export default {
  props: ["upload"],

  mixins: [helpers],

  components: {
  },

  data() {
    return {
      imgSrc: '',
      isEdited: false,
    };
  },

  created() {
    this.createImgSrc();
  },

  methods: {
    createImgSrc() {

      if (this.upload.file_url) {
        this.upload['img_src'] = this.upload['file_url'];
      }
    },

    //##############################################################################
    // ## Crop Image ##
    //##############################################################################

    onImageUpload() {
      var files = this.$refs.photoUploadFileInput.files;
      if (files.length > 0 && ['image/jpeg','image/png'].includes(files[0].type)) {
        this.getBase64Image(files[0]);
      }else{
        this.$toast.error('Please upload jpeg or png image type');
      }
    },

    getBase64Image(file) {
      var reader = new FileReader();
      var self = this;
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.imgSrc = reader.result;
        self.upload.img_src = self.imgSrc;
        self.upload.uid = Math.random().toString(16).slice(2);
        self.upload.file_name = file.name;
        self.$emit('upload-image', { 'img': self.upload, 'show_image_cropper': true });
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },

    editPhoto() {
      this.isEdited = true;
      this.$emit('edit-image', { 'img': this.upload, 'show_image_cropper': true, 'isImageEdited': this.isEdited});
    },
    deletePhoto() {
      this.$emit('delete-image', { 'img': this.upload });
    }
  },
  watch: {
  },
};
</script>
